import axiosInstance from 'shared/api/axiosInstance';


export const fetchBoosters = () => {
  return axiosInstance.get('/boosters');
};

export const putBoosters = boostersData => {
  return axiosInstance.put('/boosters', boostersData);
};